module.exports = __webpack_public_path__ + "img/pr-5.df314963.png";